var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25,
    fill: "#F6F7FF",
    stroke: "#9AA6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8416 30.6151C24.1817 30.7801 23.8516 31.4401 23.8516 32.1C23.8516 32.925 24.5115 33.75 25.5016 33.75C26.4916 33.75 27.1516 33.0901 27.1516 32.1C27.1516 30.7802 25.8317 30.1199 24.8416 30.6151Z",
    fill: "#5064FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5016 17.25C24.5115 17.25 23.8516 17.9099 23.8516 18.9V27.15C23.8516 28.1401 24.5115 28.8 25.5016 28.8C26.4916 28.8 27.1516 28.1401 27.1516 27.15V18.9C27.1516 17.9099 26.4916 17.25 25.5016 17.25Z",
    fill: "#5064FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9C16.425 9 9 16.425 9 25.5C9 34.575 16.425 42 25.5 42C34.575 42 42 34.575 42 25.5C42 16.425 34.575 9 25.5 9ZM25.5 38.7C18.24 38.7 12.3 32.76 12.3 25.5C12.3 18.24 18.24 12.3 25.5 12.3C32.76 12.3 38.7 18.24 38.7 25.5C38.7 32.76 32.76 38.7 25.5 38.7Z",
    fill: "#5064FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.fad10cfa4f96712b6e108fb854d46d0b.svg";
export { ForwardRef as ReactComponent };